
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/losing-sales-whatsapp",
      function () {
        return require("private-next-pages/webinars/losing-sales-whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/losing-sales-whatsapp"])
      });
    }
  